import AuthorizationService from '../utils/AuthorizationService';

var RoleRequiredMixin = {
  permitted: function (requiredRoles) {
    return AuthorizationService.authorizeActivity(this.props.user.get('roles').toJS(), requiredRoles)
  }
};

export default RoleRequiredMixin;